<div class="flex flex-col gap-6">
  <div>
    <h2 class="text-2xl font-bold">Contact Sales</h2>
    <p class="mt-2 text-base text-gray-600">
      Get in touch with our sales team to discuss your requirements.
    </p>
  </div>

  <form [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
    <div class="tui-form__row flex flex-col gap-4 md:flex-row">
      <div class="flex-1">
        <tui-textfield>
          <label tuiLabel>First name <span class="tui-required"></span></label>
          <input [formControl]="formGroup.controls.firstName" tuiTextfield />
        </tui-textfield>
        <tui-error
          formControlName="firstName"
          [error]="[] | tuiFieldError | async"
        />
      </div>
      <div class="flex-1">
        <tui-textfield>
          <label tuiLabel>Last name <span class="tui-required"></span></label>
          <input [formControl]="formGroup.controls.lastName" tuiTextfield />
        </tui-textfield>
        <tui-error
          formControlName="lastName"
          [error]="[] | tuiFieldError | async"
        />
      </div>
    </div>

    <div class="tui-form__row">
      <tui-textfield>
        <label tuiLabel>Company <span class="tui-required"></span></label>
        <input [formControl]="formGroup.controls.company" tuiTextfield />
      </tui-textfield>
      <tui-error
        formControlName="company"
        [error]="[] | tuiFieldError | async"
      />
    </div>

    <div class="tui-form__row">
      <tui-textfield>
        <label tuiLabel>Email <span class="tui-required"></span></label>
        <input [formControl]="formGroup.controls.email" tuiTextfield />
      </tui-textfield>
      <tui-error formControlName="email" [error]="[] | tuiFieldError | async" />
    </div>

    <div class="tui-form__row text-left">
      <tui-textfield>
        <label tuiLabel>Message <span class="tui-required"></span></label>
        <textarea
          [formControl]="formGroup.controls.message"
          tuiTextarea
          [max]="6"
          [min]="6"
        ></textarea>
      </tui-textfield>
      <tui-error
        formControlName="message"
        [error]="[] | tuiFieldError | async"
      />
    </div>

    <div class="tui-form__row mt-4 flex">
      <button
        tuiButton
        type="submit"
        appearance="primary"
        class="flex-1"
        [loading]="submitContactForm.isPending()"
      >
        Submit
      </button>
    </div>
  </form>
</div>
